import { render, staticRenderFns } from "./iam-edit-page.vue?vue&type=template&id=7ecbcf12&"
import script from "./iam-edit-page.vue?vue&type=script&lang=js&"
export * from "./iam-edit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports